import React, { useContext, useEffect, useState } from "react";
import TopBar from "../../../Components/TopBar";
import "../QuoteDetails.css";
import "./QuoteCreate.css";

import LogoAuthNavbar from "../../../NewComponents/LogoAuthNavbar";
import CreateOrderNav from "../../../NewComponents/CreateOrderNav";
import NewButton from "../../../NewComponents/NewButton";
import SelectClient from "../QuoteComponents/SelectClient";
import { DataContext } from "../../../Context/DataContext";
import { AuthContext } from "../../../Context/AuthContext";
import { useScreenTransition } from "../../../Hooks/useScreenTransition";
import { firestore, getFullHttpUrl } from "../../../firebase.config";
import { AccountType, EAST4 } from "../../../utility/enums";
import OrderSummary from "../../Order/components/OrderSummary";
import { Check } from "react-feather";
import axios from "axios";
import { NotificationContext } from "../../../Context/NotificationContext";

const QuoteCreate = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();

  const { userData, manualQuote, setManualQuote } = useContext(DataContext);
  const { signedIn } = useContext(AuthContext);
  const { showNotification } = useContext(NotificationContext);


  const [selectedTab, setSelectedTab] = useState("savedClients");
  const [clients, setClients] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [newClientEmail, setNewClientEmail] = useState("");
  const [name, setName] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [password, setPassword] = useState("");
  const [clientData, setClientData] = useState();
  const [clientTeamData, setClientTeamData] = useState();

  const [newAccountCheck, setNewAccountCheck] = useState(true);

  useEffect(() => {
    if(manualQuote && manualQuote.parsed){
      manualQuote.selectedClientType && setSelectedTab(manualQuote.selectedClientType);

      if(manualQuote.selectedClientType === "savedClients" && manualQuote.clientData){
        setClientData(manualQuote.clientData);
        manualQuote.clientTeamData && setClientTeamData(manualQuote.clientTeamData);
      }
      if(manualQuote.selectedClientType !== "savedClients" && manualQuote.clientData){
        setFirstName(manualQuote.clientData.firstName);
        setLastName(manualQuote.clientData.lastName);
        setNewClientEmail(manualQuote.clientData.email);
      }
    }
  }, [manualQuote])

  useEffect(() => {
    if (
      (windowSize.width > 767 || windowSize.orientation === "landscape") &&
      document.getElementById("mainPrimary") &&
      document.getElementById("mainSecondary")
    ) {
      if (
        document.getElementById("mainPrimary").clientHeight >
        document.getElementById("mainSecondary").clientHeight
      ) {
        document.getElementById("mainSecondary").style.minHeight = `${
          document.getElementById("mainPrimary").clientHeight
        }px`;
      } else {
        document.getElementById("mainPrimary").style.minHeight = `${
          document.getElementById("mainSecondary").clientHeight
        }px`;
      }
    }
  });


  useEffect(() => {
    if (signedIn && userData && 
      (userData.role === AccountType.OWNER  || userData.role === AccountType.SUPPORT || userData.role === AccountType.SUPPORTPLUS || userData.role === AccountType.TRANSLATER)) {

      firestore
        .collection("users").orderBy("name")
        .get()
        .then((qSnap) => {
          if (!qSnap.empty) {
            setClients(
              qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            );

          }
        })
        .catch((error) => {
          console.error("Error fetching clients:", error);
        });
    }
  }, [signedIn, userData]);

  const fetchSuggestions = ({ firstName = "", lastName = "" }) => {
    if (!firstName && !lastName) {
      setSuggestions([]);
      return;
    }

    const filteredSuggestions = clients.filter((client) => {
      const clientFirstName = client?.firstName?.toLowerCase?.() || "";
      const clientLastName = client?.lastName?.toLowerCase?.() || "";
      const searchFirstName = firstName.toLowerCase();
      const searchLastName = lastName.toLowerCase();

      if (!lastName) {
        return clientFirstName.includes(searchFirstName);
      }

      return (
        clientFirstName.includes(searchFirstName) &&
        clientLastName.includes(searchLastName)
      );
    });

    setSuggestions(filteredSuggestions.slice(0, 5));
  };

  const handleFirstNameChange = (e) => {
    const value = e.target.value;
    setFirstName(value);
    fetchSuggestions({ firstName: value, lastName });
  };

  const handleLastNameChange = (e) => {
    const value = e.target.value;
    setLastName(value);
    fetchSuggestions({ firstName, lastName: value });
  };

  const handleNewClientEmailChange = (e) => {
    const value = e.target.value;
    setNewClientEmail(value);
  };

  const handleSelect = async(data) => {
    // setEmail(email);
    // setName(name);
    // setClientId(id);
    setClientData(data);
    if (data.teamId) {
      const clientTeamDoc = await firestore.collection("teams")
        .doc(data.teamId)
        .get();
      if (clientTeamDoc.exists) {
        setClientTeamData({ ...clientTeamDoc.data(), id: data.teamId });
      }else{
        setClientTeamData(null);
      }
    }else{
      setClientTeamData(null);
    }
    localStorage.setItem('manualQuote', JSON.stringify({ parsed: true, type: checkOrderType(data.teamId ? true : false), clientData: data, selectedClientType: selectedTab,}));
    setManualQuote((q) => ({
      parsed: true,
      type: checkOrderType(data.teamId ? true : false),
      clientData: data,
      selectedClientType: selectedTab,
    }));
  };

  const checkOrderType = (isTeam) => {
    if(isTeam){
      return "business";
    }else{
      return "personal";
    }
  }

  const selectClient = (data) => {
    // setFirstName(FName);
    // setLastName(LName);
    setNewClientEmail(data.email);
    // setClientId(id);
    setClientData(data);
    if (data.teamId) {
      firestore.collection("teams")
        .doc(data.teamId)
        .onSnapshot(function (doc) {
          if (doc.exists) {
            setClientTeamData({ ...doc.data(), id: data.teamId });
          }else{
            setClientTeamData(null);
          }
        });
    }else{
      setClientTeamData(null);
    }

  };


  const handleTabChange = (tab) => {
    setSelectedTab(tab);

    setFirstName("");
    setLastName("");
    setNewClientEmail("");
    setEmail("");
    setName("");
  };


  const updateUserDetails = (data) => {

    localStorage.setItem('manualQuote', JSON.stringify({ parsed: true, type: checkOrderType(false), clientData: data, clientTeamData: null, selectedClientType: selectedTab, }));
    setManualQuote((q) => ({
      parsed: true,
      type: checkOrderType(false),
      clientData: data,
      clientTeamData: null,
      selectedClientType: selectedTab,
    }));

    transitionTo("/manualQuote/details");

  }


  const handleNewClient = async() => {
    const fullName = firstName + " " + lastName;
    if(fullName && newClientEmail){

      const data = {firstName, lastName, name: fullName, email: newClientEmail};

      await firestore.collection("users").where("email", "==", newClientEmail).get().then(async qSnap => {
        if(!qSnap.empty){
          if(newAccountCheck){
            showNotification(
              "Email Already Exists",
              `Can't create new user, email already exists.`,
              "error"
            );
            return;
          }else{
            updateUserDetails(data, false);
          }
          }else{

            if(newAccountCheck){
               const newAccountData = await axios({
                method: "post",
                url: getFullHttpUrl("createPersonalUser"),
                data: {userData: data, password: password},
              })
              const userDetails = newAccountData.data.userData;
              updateUserDetails(userDetails);

            }
            else{
              const userDoc = qSnap.docs[0];
              const userDetails = {id: userDoc.id, ...userDoc.data()}
              updateUserDetails(userDetails);
            }
  
          }
        })
      

     
      
     
    }
    return;
  }


  const handleContinueToDetails = () => {
    if (selectedTab !== "savedClients") {
      handleNewClient();
    } else {
      const data = clientData && clientTeamData ? {clientData, clientTeamData, selectedClientType: selectedTab} : {clientData, selectedClientType: selectedTab}
      localStorage.setItem('manualQuote', JSON.stringify({ ...manualQuote, ...data, type: checkOrderType(clientTeamData ? true : false), discount: manualQuote.discount ? manualQuote.discount : clientTeamData && clientTeamData.discount ? clientTeamData.discount : 0}));
      setManualQuote((q) => ({ ...q, ...data, type: checkOrderType(clientTeamData ? true : false), discount: manualQuote.discount ? manualQuote.discount : clientTeamData && clientTeamData.discount ? clientTeamData.discount : 0}));
      transitionTo("/manualQuote/details");
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };


  return (
    <>
      <TopBar />
      <div className="mainOrderContainer">
        <div className="mainOrderHeader">
          <LogoAuthNavbar isAuth={signedIn} showButtons={false} />
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <CreateOrderNav title="1. Contact" stage={1} stages={3} />
            <div></div>
          </div>
        </div>

        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <div id="mainPrimary" className="mainOrderPrimaryContent">
              <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">Client's Contact</h4>
                <div className="quotePrimaryOptions">
                  <div className="accountSettingsMenu mainOrderTabMenu grid-cols-2 ">
                    <div
                      className="accountSettingsMenuTab"
                      style={{ background: "#f7f6f7" }}
                      onClick={() => handleTabChange("savedClients")}
                    >
                      <div className="accountSettingMenuTextWrap">
                        <p
                          className={`accountSettingMenuText ${
                            selectedTab === "savedClients" ? "selectedTab" : ""
                          }`}
                        >
                          Saved Clients
                        </p>
                      </div>
                      <div className="accountSettingsMenuSpacer">
                        <div></div>
                      </div>
                    </div>
                    <div
                      className={`accountSettingsMenuTab`}
                      style={{ background: "#f7f6f7" }}
                      onClick={() => handleTabChange("newClients")}
                    >
                      <div className="accountSettingMenuTextWrap">
                        <p
                          className={`accountSettingMenuText ${
                            selectedTab === "newClients" ? "selectedTab" : ""
                          }`}
                        >
                          New Client
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {selectedTab === "savedClients" && (
                  <div className="selectClientTab">
                    <SelectClient
                      clients={clients}
                      handleSelectedClient={handleSelect}
                      defaultSelecedClient={clientData}
                    />
                  </div>
                )}
                {selectedTab === "newClients" && (
                  <>
                    <div className="w-full grid gap-4 sm:grid-cols-2 grid-cols-1">
                      <input
                        className="accountDetailsSearchInput"
                        placeholder="First Name"
                        value={firstName}
                        onChange={(e) => handleFirstNameChange(e)}
                      />
                      <input
                        className="accountDetailsSearchInput"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={(e) => handleLastNameChange(e)}
                      />
                      <input
                        className="accountDetailsSearchInput emai0lInput"
                        placeholder="Email"
                        value={newClientEmail}
                        onChange={(e) => handleNewClientEmailChange(e)}
                      />
                      {newAccountCheck && <input
                        className="accountDetailsSearchInput"
                        placeholder="Password (Not Required)"
                        value={password}
                        onChange={(e) => handlePasswordChange(e)}
                      />}

                    </div>

                    <div className="hardCopyCheckboxLine" onClick={() => setNewAccountCheck(ss => !ss)}>
                      <div className="hardCopyCheckbox" style={{background: newAccountCheck ? "#1EB8BC" : "transparent",}}>
                        <Check className="hardCopyCheck" style={{ opacity: newAccountCheck ? 1 : 0, }} />
                      </div>
                      <p className="hardCopyCheckboxText">Create new user account</p>
                    </div>

                    {(firstName || lastName) && suggestions.length > 0 && (
                      <div className="matchClientData">
                        <p>
                          We found similar saved clients. Would you like to
                          select one of them for this quote?
                        </p>
                        <div className="suggestionOptionslayout">
                          {suggestions.map((el) => (
                            <>
                              <div
                                key={el.id}
                                className={`suggestionOption ${
                                  isButtonEnabled
                                    ? "border-2 border-primary"
                                    : "border-2 border-gray-300"
                                }`}
                                onClick={() =>
                                  selectClient(
                                    el
                                    // el.firstName,
                                    // el.lastName,
                                    // el.email,
                                    // el.id
                                  )
                                }
                              >
                                {el.name}
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>

              <div>
                <div className="quoteSubmitButtonContainer">
                  <NewButton
                    text="Continue to Details"
                    disabled={!(selectedTab === "savedClients" ?
                       clientData : firstName && newClientEmail)
                    }
                    onClick={handleContinueToDetails}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mainOrderSecondaryContent">
            <div className="mainOrderSecondaryContentWrap relative">
              {manualQuote && clientData ? <OrderSummary order={manualQuote} certified={manualQuote.certified} pagesCount={manualQuote.pagesCount}
               languageFrom={manualQuote.languageFrom} languageTo={manualQuote.languageTo} />
              :<div className="orderSummary">
                <h2 className="orderSummaryTitle">Summary</h2>
                <div className="orderSummaryTotal">
                  <h4>Total</h4>
                  <h4>$0.00</h4>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuoteCreate;
